import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Card, Center, Icon, Spinner } from "@barev/ui";
import {
  errorText,
  haptic,
  navigate,
  useI18n,
  useToast,
  useTRPC,
} from "@barev/web";
import { itemHint, itemName } from "../lib.tsx";

/** Чек-лист документов, которые лучше собрать до переезда; отметки сохраняются в заявке на переезд */
export function Docs() {
  const { t, locale } = useI18n();
  const trpc = useTRPC();
  const qc = useQueryClient();
  const toast = useToast();
  const me = useQuery(trpc.client.me.queryOptions());
  const plan = useQuery(trpc.client.relocation.get.queryOptions());
  const toggle = useMutation(
    trpc.client.relocation.toggleDoc.mutationOptions({
      onMutate: () => haptic.tap(),
      onSuccess: () =>
        void qc.invalidateQueries({
          queryKey: trpc.client.relocation.get.queryKey(),
        }),
      onError: (e) => toast(errorText(t, e), "error"),
    }),
  );
  if (!plan.data)
    return (
      <Center>
        <Spinner />
      </Center>
    );
  const lead = plan.data.lead;

  return (
    <main className="app">
      <header className="screen-head">
        <h1 className="screen-head__title">{t("client.docs.title")}</h1>
      </header>
      <p className="bc-muted" style={{ margin: "-6px 0 0" }}>
        {t("client.docs.sub")}
      </p>
      {!lead && (
        <Card tone="perks" tight>
          <a
            href="#/"
            className="bc-small"
            style={{ fontWeight: 600, color: "inherit" }}
          >
            {t("client.docs.needPlan")}
          </a>
        </Card>
      )}
      {lead && lead.docs.length > 0 && (
        <Card style={{ padding: 8 }}>
          <ul className="docs">
            {(lead?.docs ?? []).map((d) => {
              const hint = itemHint(plan.data.names, "DOC", d, locale);
              return (
                <li key={d.id}>
                  <button
                    className="doc"
                    aria-pressed={d.checked}
                    disabled={toggle.isPending}
                    onClick={() =>
                      toggle.mutate({ docId: d.id, checked: !d.checked })
                    }
                  >
                    <span className="doc__box" aria-hidden="true">
                      {d.checked && (
                        <Icon name="check" size={16} strokeWidth={3} />
                      )}
                    </span>
                    <span>
                      <b>{itemName(plan.data.names, "DOC", d, locale)}</b>
                      {hint && (
                        <span className="bc-small bc-muted">{hint}</span>
                      )}
                    </span>
                  </button>
                </li>
              );
            })}
          </ul>
        </Card>
      )}
      {me.data && (
        <button
          className="bc-btn bc-btn--light bc-btn--block"
          onClick={() => navigate("/chat")}
        >
          <Icon name="chat" size={18} />
          {t("client.docs.ask")}
        </button>
      )}
    </main>
  );
}
